import styled from 'styled-components';
import scrollDiscreto from '@/styles/scrollbar';

export const Body = styled.div`
  display: flex;
  margin-top: 110px;
  padding-bottom: 20px;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  height: 50%;

  padding-bottom: 50px;
  overflow-y: scroll;
  max-height: 50vh;

  ${scrollDiscreto({ descendentes: true })}
`;

export const Image = styled.img`
  max-width: 200px;
  margin: 5px;
  cursor: pointer;
  border: ${props => (props.selected ? '3px solid var(--secondary)' : 'none')};
  transform: ${props => (props.selected ? 'scale(1.1)' : 'scale(1)')};
  transition: all 0.4s;
  &:hover {
    transform: scale(1.1);
  }
`;

export const Filters = styled.div`
  display: flex;
  border-bottom: 1px solid #d9dce9;
  width: 100%;
  height: 40px;
  position: absolute;
  margin-top: 65px;
  left: 0;
  align-items: center;
  justify-content: center;
  .select {
    width: 100%;
  }
`;
